import "../../index56.css";
import { jsxs as r, jsx as s } from "react/jsx-runtime";
import { _ as c } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
const o = "_spinner_50bgg_1", p = "_spinner-bounce_50bgg_9", n = {
  spinner: o,
  spinnerBounce: p
};
function l(e) {
  const { className: i } = e;
  return /* @__PURE__ */ r("div", { className: c(n.spinner, i), children: [
    /* @__PURE__ */ s("div", { className: n.spinnerBounce }),
    /* @__PURE__ */ s("div", { className: n.spinnerBounce }),
    /* @__PURE__ */ s("div", { className: n.spinnerBounce })
  ] });
}
export {
  l as default
};
